import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import countriesEN from "./locales/countries.en.json";
import countriesES from "./locales/countries.es.json";
import countriesZH from "./locales/countries.zh.json";
import es from "./locales/es.json";
import zh from "./locales/zh.json";

const languageDetector = new LanguageDetector(null, {
  convertDetectedLanguage: (lng) => lng.split("-")?.[0]?.toLowerCase() || "en",
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "es", "zh"],
    resources: {
      en: {
        translation: en,
        countries: countriesEN,
      },
      es: {
        translation: es,
        countries: countriesES,
      },
      zh: {
        translation: zh,
        countries: countriesZH,
      },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    debug: false,
  });

export default i18n;
